<div class="container-xl {{partnerName}}">
    <header>
        <div class="header-left" [ngStyle]="{'align-items':partnerName===PartnerNamesEnum.AVEXTRA?'flex-start':'center'}">
            <ng-container *ngIf="!isPartnerPage">
                <a class="header-logo" href="/">
                    <img src="/Copeia.svg" alt="Copeia" />
                </a>
            </ng-container>
            <ng-container *ngIf="isPartnerPage">
                <ng-container [ngSwitch]="partnerName">
                    <ng-container *ngSwitchCase="PartnerNamesEnum.ADREX">
                        <a class="header-logo" href="/private/adrex/cannabisantrag">
                            <img style="width:120px;" src="/images/private/adrex/ADREXpharma-pos.svg" alt="Adrex" />
                        </a>
                    </ng-container>
                    <ng-container *ngSwitchCase="PartnerNamesEnum.AVEXTRA">
                        <a class="header-logo" href="/private/avextra/cannabisantrag">
                            <img style="width: 140px; height: 100%;" src="/images/private/avextra/AvextraWortmarke_blue.svg" alt="Avextra" />
                        </a>
                    </ng-container>
                    <ng-container *ngSwitchCase="PartnerNamesEnum.ALTHEA">
                        <a class="header-logo" href="/private/althea/cannabisantrag">
                            <img style="width: 100px; height: 100%;" src="/images/private/althea/Althea_Full colour_RGB.svg" alt="Althea" />
                        </a>
                    </ng-container>
                    <ng-container *ngSwitchCase="PartnerNamesEnum.BETAHEALTH">
                        <a class="header-logo" href="/private/betahealth/cannabisantrag">
                            <img style="width:160px;" src="/images/private/betahealth/Betahealth_Logo.svg" alt="BetaHealth" />
                        </a>
                    </ng-container>
                    <ng-container *ngSwitchCase="PartnerNamesEnum.SWISS">
                        <a class="header-logo" href="/private/ch/cannabisantrag">
                            <img style="width:220px;" src="/images/private/swiss/Copeia Swiss Logo.svg" alt="Swiss" />
                        </a>
                    </ng-container>
                    <ng-container *ngSwitchCase="PartnerNamesEnum.FOUR_20_PHARMA">
                        <a class="header-logo" href="/private/420pharma/cannabisantrag">
                            <img style="width:160px;" src="/images/private/420pharma/Logo.svg" alt="Four 20 Pharma" />
                        </a>
                        <div class="header-title">
                            <img src="/images/private/420pharma/plus.svg" alt="Plus.svg">CAM ANTRAG
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <a class="header-logo" href="/">
                            <img src="/Copeia.svg" alt="Copeia" />
                        </a>
                    </ng-container>
                </ng-container>
            </ng-container>
            <div class="header-title" *ngIf="!isPartnerPage">{{headerTitle}}</div>
        </div>
        <div class="header-right">
            <ul *ngIf="showNav">
                <li class="first" placement="right" ngbTooltip="Info" (click)="onIconClick('info')">
                    <img src="/images/icons/Info.svg" alt="Info" />
                </li>
                <li placement="bottom" ngbTooltip="Antrag neu starten?" (click)="onIconClick('reload')">
                    <img src="/images/icons/Reload_Icon.svg" alt="Reload" />
                </li>
                <li placement="bottom" ngbTooltip="Load" id="file-input-opener" (click)="onIconClick('load')">
                    <img src="/images/icons/Load.svg" alt="Load" />
                </li>
                <li placement="bottom" ngbTooltip="Save" (click)="onIconClick('save')">
                    <img src="/images/icons/Save.svg" alt="Save" />
                </li>
                <li placement="bottom" ngbTooltip="Print" (click)="onIconClick('print')">
                    <img src="/images/icons/Print.svg" alt="Print" />
                </li>
                <!--<li placement="bottom" ngbTooltip="Email" (click)="onIconClick('email')">
                    <img src="/images/icons/Email.svg" alt="Email" />
                </li>
                <li placement="bottom" ngbTooltip="Document" (click)="onIconClick('document')">
                    <img src="/images/icons/Document.svg" alt="Document" />
                </li>-->
                <li class="last" placement="left" ngbTooltip="Menu" (click)="toggleStepper()">
                    <img src="/images/icons/Donat.svg" alt="Donat" />
                </li>
            </ul>
        </div>
    </header>

</div>
